import {isNumber} from 'ramda-adjunct';

import {getSize} from '../../../foundation/src/utils/getSize';
import {CSSDimension} from '../types/CSSDimension';
import {Integer} from '../types/Integer';

export const getCssSize = (size: CSSDimension | Integer | undefined) =>
  isNumber(size) ? getSize(size) : size;
